var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"performance"},[_c('div',{staticClass:"banner"}),_c('div',{staticClass:"container-auto wrapper"},[_c('workStatus'),_c('div',{staticClass:"flex justify-between mt-20"},[_c('performancePolicy'),_c('ServiceArea')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }